import React from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import SchedulePage from './pages/SchedulePage';
import ScheduleEditor from './pages/ScheduleEditor';
import SignIn from './components/SignIn';
import ProtectedRoute from './components/ProtectedRoute';
import "./App.css";

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<SchedulePage />} />
        <Route path="/editor" element={<ProtectedRoute><ScheduleEditor /></ProtectedRoute>} />
        <Route path="/login" element={<SignIn />} />
      </Routes>
    </Router>
  );
};

export default App;